<script lang="ts">
  /**
   * How to play: the basics, as a page to read (the shell's `FullPage`,
   * chevron dress). Each paragraph opens on the word that names what it is
   * about, set in the accent.
   *
   * Reachable from the profile sheet, from Settings and from the Game menu,
   * sharing this one component. Each caller owns its own `open` and closes it
   * in `onclose`; the page pushes its own history entry, so Back closes
   * whichever one is on top.
   */
  import { FullPage } from '@artibens/app-shell';

  import { howToPlayBasics } from '../copy/explanations.js';

  const { open, onclose }: { open: boolean; onclose: () => void } = $props();

  /** Each basic, split after its first word: the lead, and the rest of the sentence. */
  const topics = howToPlayBasics().map((line) => {
    const space = line.indexOf(' ');
    return space === -1
      ? { lead: line, rest: '' }
      : { lead: line.slice(0, space), rest: line.slice(space) };
  });
</script>

<FullPage {open} title="How to play" dress="chevron" {onclose} testid="how-to-play-sheet">
  <div class="help">
    <section class="help-section">
      <h3 class="help-heading">The basics</h3>
      {#each topics as topic (topic.lead)}
        <p class="help-rule"><span class="help-lead">{topic.lead}</span>{topic.rest}</p>
      {/each}
    </section>
    <p class="help-note">
      Every mode, every duel and every curse says what it does on the card you pick it from.
    </p>
  </div>
</FullPage>

<style>
  .help {
    padding: var(--ui-space-2) var(--ui-space-2) var(--ui-space-6);
  }

  .help-heading {
    margin: 0 0 var(--ui-space-3);
    font: var(--ui-text-heading);
    color: var(--ui-ink);
  }

  .help-rule {
    margin: 0 0 var(--ui-space-3);
    font: var(--ui-text-body);
    line-height: 1.55;
    color: var(--ui-ink);
  }

  .help-lead {
    font-weight: 800;
    color: var(--ui-accent);
  }

  .help-note {
    margin: var(--ui-space-5) 0 0;
    font: var(--ui-text-label);
    line-height: 1.5;
    color: var(--ui-ink-2);
  }
</style>
